import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import Insurance from '@/modules/common/common/models/APP/Insurance'

export default class ForeignHealthInsurance extends Insurance {
  coverages: AbstractAccordion<any> | null
  optionalCoverages: AbstractAccordion<any> | null

  constructor(data: Partial<ForeignHealthInsurance>) {
    super(data)

    this.coverages = data.coverages ?? null
    this.optionalCoverages = data.optionalCoverages ?? null
  }

  getMandatoryFeatures(): any[] {
    return [this.coverages, this.optionalCoverages].filter((v) => !!v)
  }
}
